/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import 'bootstrap-icons/font/bootstrap-icons.css'
import './bootstrap.min.css';
require("prismjs/themes/prism-solarizedlight.css")

// const addScript = url => {
//     const script = document.createElement("link")
//     script.src = url
//     script.async = true
//     document.body.appendChild(script)
//   }
  
//   export const onClientEntry = () => {
//     window.onload = () => {
//       addScript("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.7.2/font/bootstrap-icons.css")
//     //   addScript("https://fast.wistia.com/assets/external/E-v1.js")
//     }
//   }